import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import p_nav_location from "../../Assets/Images/p_nav_location.svg";
import p_nav_about_outline from "../../Assets/Images/p_nav_about_outline.svg";
import p_nav_setting_outline from "../../Assets/Images/p_nav_setting_outline.svg";
import { FiLogIn } from "react-icons/fi";
import { FaSearch } from "react-icons/fa";


const GuestUserSideBar = ({ isOpen, user, onClose, fromPage }) => {

    const navigate = useNavigate();
    const storedLocation = JSON.parse(localStorage.getItem("GuestLocation"));
    console.log('locationData-------', storedLocation);

    return (
        <>
            {isOpen && (<div className="offcanvas-backdrop fade show" onClick={onClose} ></div>)}
            <div className={`offcanvas sidebar-action ${isOpen ? "show" : ""}`} tabIndex="-1"   >
                <div className="offcanvas-body p-0">
                    <div className="profileDetails primary-bg p-3 text-white d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <img src={`https://pingle.s3.ap-south-1.amazonaws.com/uploads/user/user.jpg`} className="rounded-3" width={"84px"} height={"81px"} />
                            <div className="ms-2">
                                <div className="ff-poppins-semiBold fs-16">
                                    Guest Login
                                </div>
                                <div className="ff-balooPaaji2-regular fs-12">
                                    UID:{user?.user_id}
                                </div>
                                <div className="ff-balooPaaji2-regular fs-12">
                                    <img src={p_nav_location} width={"12px"} height={"12px"} className="me-1" />
                                    {storedLocation?.locationData?.locality || storedLocation?.locationData?.select_locality}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-2">

                        <div className="d-flex p-3" onClick={() => {
                            if (fromPage == 'searchScreen') {
                                onClose()
                            } else {
                                navigate('/search-store')
                            }
                        }} role="button">
                            <FaSearch size={20} color="rgb(110, 110, 110)" />
                            <div className="ff-poppins-regular fs-16 ms-3">
                                Pingle  Search
                            </div>
                        </div>


                        <div className="d-flex p-3" onClick={() => navigate('/aboutPingle')} role="button">
                            <img src={p_nav_about_outline} width={"24px"} height={"24px"} />
                            <div className="ff-poppins-regular fs-16 ms-3">
                                About Pingle
                            </div>
                        </div>

                        <div className="d-flex p-3" role="button" onClick={() => navigate('/settings')}>
                            <img
                                src={p_nav_setting_outline}
                                width={"24px"}
                                height={"24px"}
                            />
                            <div className="ff-poppins-regular fs-16 ms-3">Settings</div>
                        </div>
                        <div className=" ">
                            <button className="sideBar-loginBtn d-flex align-items-center p-3" onClick={() => navigate('/login', { state: { fromGuest: true } })}  >
                                <FiLogIn size={22} />
                                <span className="ff-poppins-regular fs-16 ms-3">Login</span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            {/* <div className="modal-backdrop show" onClick={} ></div> */}
        </>
    )
}

export default GuestUserSideBar;